import { DEV_ONLY } from 'common/globalConstants'
import { findHashes } from './findHashes'

export const getHTMLWithLinkedTags = (html: string, tags = []) => {
  let correctHTML = html

  if (DEV_ONLY) {
    const tagged: string[] = Array.from(new Set(tags.length ? tags : findHashes(html) || []))

    tagged.sort((a, b) => b?.length - a?.length)

    tagged.map(tag => {
      const hashlessTag = tag.replace('#', '')

      const linkEle = `<a href="/feed/tag/${hashlessTag}/" class="hashtag" target="_blank">${tag}</a>`

      correctHTML = correctHTML.replaceAll(tag, linkEle)
    })
  }

  return correctHTML
}
